import mutations from './mutations'

let state = {

}

export default {
    state,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/common/index.js